import React from "react";

import { BoldText } from "components/BoldText/BoldText";

import styles from "../styles.module.scss";

export function Header() {
  return <BoldText className={styles.productsHeader}>Товары</BoldText>;
}
